import { getRefreshToken } from "../services/api";
import { useDispatch, useSelector } from "react-redux";
import { setTokens } from "../redux/Slices/authSlice";
import { useConfig } from "../App";
export const useRefreshToken = () => {
  const cfg = useConfig(); 
  const proxyString = cfg.config.services.PROXY_STRING;
  const refreshApiString = cfg.config.services.REFRESH_API_STRING;
  const apiUrl = `${proxyString}${refreshApiString}`;
  const sourceHeader = cfg.config.services.API_SOURCE_HEADER;
  // check redux 
  const dispatch = useDispatch();
 // const userName = useSelector((state) => state.auth.userProfile.username); 
   const token = useSelector((state) => state.auth.refreshToken);
 // console.log("USERNAME", userName);
  const refreshToken = async(refreshToken, userName) => {
    //const userName = accessTokenData.userProfile.username;
    //const token = accessTokenData.refreshToken;
    // build payload
     const payload = {
      username: userName,
    };
    const { refreshTokenData } = await getRefreshToken(payload,refreshToken,apiUrl,sourceHeader);

    // store in redux 
     dispatch(
      setTokens({
        accessToken: refreshTokenData.accessToken,
        refreshToken: token,
        expiresAt: refreshTokenData.expiresAt
      })
    );

    return await refreshTokenData;
  }
  return { refreshToken };
}
